import React from "react";
import menu from "../assets/images/icon/menu.png";
import search from "../assets/images/icon/search-normal.png";
import sun from "../assets/images/icon/sun.png";
import notification from "../assets/images/icon/notification.png";
import notificationstatus from "../assets/images/icon/notification-status.png";
import avatr from "../assets/images/icon/Avatr.png";
import { Link, useLocation } from "react-router-dom";
import useApp from "hooks/useApp";
import { CHANGE_STATE } from "reducers/app.reducer";
import Select from "components/Select";
import AvatarDropdown from "./AvatarDropDown";

const Header = () => {
  const { pathname } = useLocation();
  const pathnames = pathname.split("/").filter((x) => x);
  const { isSidebarOpen, dispatch } = useApp();

  return (
    <div
      className="header"
      style={{ borderBottom: pathname !== "/" ? "1px solid #C9C9C9" : "" }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-4">
          <img
            src={menu}
            alt="Menu"
            onClick={() => {
              dispatch({
                type: CHANGE_STATE,
                payload: {
                  isSidebarOpen: !isSidebarOpen,
                },
              });
            }}
          />

          <div>
            <h2>Payroll</h2>
            {pathname !== "/" && (
              <div className="breadcrumb-container">
                <Link to="/" className="breadcrumb-link">
                  Home
                </Link>

                {pathnames.map((value, index) => {
                  const to = `/${pathnames.slice(0, index + 1).join("/")}`;
                  return (
                    <span key={to}>
                      {" > "}
                      <Link to={to} className="breadcrumb-link">
                        {value.replaceAll("-", " ")}
                      </Link>
                    </span>
                  );
                })}
              </div>
            )}
          </div>
          {pathname === "/" && (
            <form>
              <div className="search-input">
                <input type="text" />
                <img className="search-icon" src={search} alt="Search" />
              </div>
            </form>
          )}
        </div>
        <div className="d-flex align-items-center gap-4">
          <div>
            <Select
              fullWidth
              // label="select company*"
              selectClass="header-select-class"
              placeholder="Select company"
              options={[
                {
                  label: "Company 1",
                  value: "com_affa65d93030f0118b3d6045bdc7c627",
                },
                {
                  label: "Company 2",
                  value: "com_affa65d93030f01185467465741324c54",
                },
                {
                  label: "Company 3",
                  value: "com_affa65d93030f0118b3d6045bdc745d6",
                },
              ]}
            />
          </div>

          <AvatarDropdown imgUrl={avatr} />
        </div>
      </div>
    </div>
  );
};

export default Header;
